import { createXiaowanApi } from './api'

type XiaowanApi = ReturnType<typeof createXiaowanApi>
type ChatInput = Parameters<XiaowanApi['chat']>[0]

export const loadXiaowanInitialData = async (api: XiaowanApi) => {
  try {
    const [agentsResponse, conversationsResponse] = await Promise.all([
      api.getAgents(),
      api.getConversations(),
    ])
    return { agentsResponse, conversationsResponse }
  } catch {
    return null
  }
}

export const requestXiaowanChat = async (api: XiaowanApi, input: ChatInput) => {
  try {
    return {
      kind: 'response' as const,
      response: await api.chat(input),
    }
  } catch {
    return {
      kind: 'fallback' as const,
      message: {
        content: '我是小万同学，不仅是你的全能数字助手，更是你的思想伙伴和资深战略顾问。我能帮你认知重构、深度博弈问题本质，还能提供策略性执行方案。比如你可以问:',
        suggestions: ['帮我拆解一个商业模式', '分析竞品数据', '生成营销文案'],
      },
    }
  }
}

export const loadXiaowanConversation = async (api: XiaowanApi, uuid: string) => {
  try {
    const [conversationResponse, messagesResponse] = await Promise.all([
      api.getConversation(uuid),
      api.getMessages(uuid),
    ])
    return { conversationResponse, messagesResponse }
  } catch {
    return null
  }
}
